import { Flex } from 'components/shared/flex'
import { usePostTaskSetApi, usePutTaskSetApi } from 'api/task_set'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useContext, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Form, useEffectSkipFirst, useForm } from 'utils/hooks'
import { ApiError } from 'utils/network/api_hooks'
import { TaskSet, TaskSetForm } from 'entities/task_set'

export type FormViewProps = {
    form: Form<TaskSetForm>
    apiError: ApiError
}

const FormView = ({ form, apiError }: FormViewProps) => {
    return (
        <>
            <Flex></Flex>
        </>
    )
}

type NewTaskSetFormProps = {
    onComplete?: () => void
}

export const NewTaskSetForm = (props: NewTaskSetFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePostTaskSetApi()
    const form = useForm<TaskSetForm>({ })
    const [show, setShow] = useState<boolean>(false)

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                setShow(false)
                props.onComplete()
            }
        }
    }, [api.loading])

    const handleClose = () => {
        setShow(false)
    }

    return (
        <>
            <Button
                variant="success"
                onClick={() => {
                    setShow(true)
                }}
            >
                新規登録
            </Button>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>TaskSetの登録</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <FormView form={form} apiError={api.apiError} />
                    </>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        閉じる
                    </Button>
                    <Button variant="success" onClick={handleUpdate}>
                        登録
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
type EditTaskSetFormProps = {
    taskSet: TaskSet
    show: boolean
    onClose: () => void
    onComplete?: () => void
}

export const EditTaskSetForm = (props: EditTaskSetFormProps): JSX.Element => {
    const globalState = useContext(GlobalStateContext)
    const api = usePutTaskSetApi()
    const form = useForm<TaskSetForm>(props.taskSet)

    useEffectSkipFirst(() => {
        form.set(props.taskSet)
    }, [props.taskSet])

    const handleUpdate = () => {
        api.execute(form)
    }

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            if (props.onComplete) {
                props.onComplete()
            }
        }
    }, [api.loading])

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>TaskSetの編集</Modal.Title>
            </Modal.Header>
            <Modal.Body>{form.object.id && <FormView form={form} apiError={api.apiError} />}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onClose}>
                    閉じる
                </Button>
                <Button variant="success" onClick={handleUpdate}>
                    更新
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
